import { Link } from 'react-router-dom';
import { instalacion } from '@tanteo/compartido/instalacion';
import { Lista, PaginaLegal, Pendiente, Seccion, TablaLegal } from './PaginaLegal';

/** Borrador público de la Política de Tratamiento de Datos Personales de la plataforma. */
export function PoliticaDatos() {
  const marca = instalacion.nombre;
  return (
    <PaginaLegal titulo="Política de Tratamiento de Datos Personales">
      <Seccion titulo="Identificación del Responsable">
        <Lista>
          <li>
            <strong>Responsable:</strong> <Pendiente>[TBD: nombre completo o razón social]</Pendiente>,{' '}
            <Pendiente>[TBD: tipo y número de documento o NIT]</Pendiente>, titular de la marca «{marca}».
          </li>
          <li><strong>Domicilio:</strong> <Pendiente>[TBD: ciudad]</Pendiente>, Colombia.</li>
          <li><strong>Dirección:</strong> <Pendiente>[TBD: dirección física]</Pendiente>.</li>
          <li><strong>Correo de atención:</strong> <Pendiente>[TBD: correo de contacto]</Pendiente>.</li>
          <li><strong>Teléfono:</strong> <Pendiente>[TBD: teléfono]</Pendiente>.</li>
          <li><strong>Sitio:</strong> {window.location.origin}/legal/politica-datos</li>
        </Lista>
      </Seccion>

      <Seccion titulo="Capítulo I — Objeto y alcance">
        <p>
          <strong>Artículo 1. Objeto.</strong> Esta política regula el tratamiento de los datos personales en {marca}, una
          plataforma para que micronegocios registren su operación diaria: ventas en mostrador, comprobantes internos de
          venta, cuadre de caja, gastos, inventario y recetas, reportes y avisos por Telegram. Desarrolla el derecho de
          habeas data conforme a la Ley 1581 de 2012.
        </p>
        <p><strong>Artículo 2. Alcance.</strong> Aplica a los datos de:</p>
        <Lista numerada>
          <li><strong>Propietarios:</strong> personas naturales que crean una cuenta y registran un negocio.</li>
          <li><strong>Miembros del equipo de un negocio:</strong> cajeros, contadores y otros propietarios invitados por el propietario.</li>
          <li><strong>Terceros de un negocio:</strong> clientes y proveedores que el negocio registra, directamente o mediante el formulario público de registro de clientes.</li>
          <li><strong>Personal de la plataforma:</strong> personas con acceso al panel de administración de {marca}.</li>
          <li><strong>Visitantes</strong> del formulario público de registro de clientes.</li>
        </Lista>
      </Seccion>

      <Seccion titulo="Capítulo II — Marco normativo">
        <p>
          <strong>Artículo 3. Normativa aplicable.</strong> Constitución Política (arts. 15 y 20); Ley Estatutaria 1581 de
          2012; Decreto 1074 de 2015 (capítulos 25 y 26 del título 2, parte 2, libro 2); Ley 527 de 1999; Circular Única
          de la Superintendencia de Industria y Comercio (título V) y Circulares Externas 005 de 2017 y 003 de 2025. Ante
          dos normas aplicables prevalece la que ofrezca mayor protección al titular.
        </p>
      </Seccion>

      <Seccion titulo="Capítulo III — Definiciones">
        <p><strong>Artículo 4. Definiciones.</strong></p>
        <Lista>
          <li><strong>Titular:</strong> persona natural cuyos datos se tratan.</li>
          <li><strong>Responsable:</strong> quien decide sobre la base de datos y su tratamiento.</li>
          <li><strong>Encargado:</strong> quien trata datos por cuenta del Responsable.</li>
          <li><strong>Transmisión:</strong> comunicación de datos del Responsable a un Encargado, dentro o fuera de Colombia, para que los trate por su cuenta.</li>
          <li><strong>Transferencia:</strong> envío de datos a otro Responsable, dentro o fuera de Colombia.</li>
          <li><strong>Negocio:</strong> el establecimiento registrado en {marca} por su propietario, que contrata el servicio.</li>
          <li><strong>Tercero:</strong> cliente o proveedor que un Negocio registra.</li>
          <li>
            {/* eslint-disable-next-line no-restricted-syntax -- aclaración legal que niega la factura */}
            <strong>Comprobante de venta:</strong> documento interno que la plataforma genera por cada venta. No es factura de venta ni documento equivalente.
          </li>
        </Lista>
      </Seccion>

      <Seccion titulo="Capítulo IV — Doble rol">
        <p><strong>Artículo 5. Segregación de roles.</strong> {marca} actúa en dos calidades distintas:</p>
        <Lista>
          <li>
            <strong>Como Responsable</strong>, sobre los datos de las cuentas (propietarios y miembros), los de
            identificación de cada Negocio, los registros de sesión y seguridad, el chat de Telegram vinculado y los datos
            del personal de la plataforma.
          </li>
          <li>
            <strong>Como Encargado</strong>, sobre los datos que cada Negocio registra en su operación (sus clientes, sus
            proveedores y el uso que hace de los datos de su equipo), por cuenta y bajo instrucciones del Negocio, que es el
            Responsable. Esta relación se rige por el contrato de transmisión incluido en los{' '}
            <Link to="/legal/terminos-servicio" className="text-info underline">Términos de Servicio</Link> (cláusula 9).
          </li>
        </Lista>
        <p><strong>Artículo 6. Matriz de actividades.</strong></p>
        <TablaLegal
          titulos={['Actividad', 'Responsable', 'Encargado']}
          filas={[
            ['Crear la cuenta, dar acceso por código y administrarla', marca, '—'],
            ['Registrar el Negocio y a su titular', marca, '—'],
            ['Invitar miembros y asignarles un rol', 'Negocio', marca],
            ['Registrar clientes y proveedores (desde la app o por el formulario público)', 'Negocio', marca],
            ['Obtener la autorización del cliente', 'Negocio', `${marca} provee la casilla y guarda la fecha`],
            ['Asociar compras a un cliente y emitir comprobantes', 'Negocio', marca],
            ['Imprimir en el comprobante el nombre de quien atendió', 'Negocio', marca],
            ['Suprimir los datos de un cliente', 'Negocio', `${marca} provee la acción y la ejecuta`],
            ['Atender los derechos de clientes y proveedores del Negocio', 'Negocio', `${marca} da traslado`],
            ['Atender los derechos de propietarios, miembros y personal', marca, '—'],
            ['Enviar resúmenes al chat de Telegram vinculado', `${marca}, a pedido del propietario`, '—'],
            ['Respaldos, seguridad y auditoría', marca, `${marca}, sobre los datos del Negocio`],
          ]}
        />
      </Seccion>

      <Seccion titulo="Capítulo V — Categorías de datos y finalidades">
        <p><strong>Artículo 7. Datos de propietarios y miembros ({marca} como Responsable).</strong></p>
        <p><em>Categorías:</em></p>
        <Lista>
          <li><strong>Identificación:</strong> nombres, apellidos, nombre visible, tipo y número de documento.</li>
          <li><strong>Contacto:</strong> correo electrónico (con el que se entra) y celular.</li>
          <li><strong>Del Negocio:</strong> nombre comercial, tipo y número de documento de su titular y celular.</li>
          <li><strong>Prueba de la autorización:</strong> fecha y hora en que se otorgó.</li>
          <li><strong>Sesión y seguridad:</strong> dirección IP y agente de usuario de cada sesión, y registros de acceso del proveedor de autenticación.</li>
          <li><strong>Auditoría:</strong> acciones relevantes, como invitaciones, anulaciones, vinculación del bot y fallos de pantalla con su mensaje de error.</li>
          <li><strong>Telegram:</strong> identificador del chat que el propietario vincula.</li>
        </Lista>
        <p><em>Finalidades:</em></p>
        <Lista numerada>
          <li>Crear, autenticar y administrar la cuenta. El acceso es por un código de un solo uso enviado al correo, sin contraseña.</li>
          <li>Prestar el servicio: roles y permisos, e identificación de quien atendió cada venta. El nombre del cajero queda impreso en el comprobante.</li>
          <li>Enviar avisos operativos del Negocio por la app, por Telegram o por correo.</li>
          <li>Proteger la cuenta: mostrar y desconectar sesiones, auditar acciones sensibles y detectar fallos.</li>
          <li>Dar soporte.</li>
          <li>Cumplir obligaciones legales y atender requerimientos de autoridad competente.</li>
          <li>
            {/* eslint-disable-next-line no-restricted-syntax -- el cobro futuro del servicio, no un documento de venta */}
            <Pendiente>[TBD: facturación y cobro, si se establecen planes de pago.]</Pendiente>
          </li>
        </Lista>
        <p>
          <em>Qué ve el personal de la plataforma:</em> la identidad del Negocio, el nombre visible y el correo de su
          propietario y la fecha en que autorizó el tratamiento. El número de documento se muestra enmascarado, solo con sus
          cuatro últimos dígitos. El personal nunca ve montos, datos de los clientes del Negocio ni el detalle de una venta,
          y sus consultas quedan registradas.
        </p>
        <p>
          <strong>Artículo 8. Datos del personal de la plataforma ({marca} como Responsable).</strong> Correo, nombres,
          apellidos, celular y cargo, para otorgar, limitar y auditar su acceso al panel de administración.
        </p>
        <p><strong>Artículo 9. Datos de terceros de un Negocio ({marca} como Encargado).</strong></p>
        <p><em>Categorías:</em></p>
        <Lista>
          <li>
            <strong>Clientes:</strong> tipo y número de documento; nombres y apellidos o razón social (con NIT y dígito de
            verificación); celular; correo; fecha de la autorización; origen del registro (app o formulario público);
            compras asociadas.
          </li>
          <li>
            {/* eslint-disable-next-line no-restricted-syntax -- la factura que el proveedor emite, no la del negocio */}
            <strong>Proveedores:</strong> documento o NIT y nombre, y los datos que trae el código QR de la factura electrónica que el Negocio lee: código único (CUFE), NIT, fecha y valores. La plataforma no guarda el archivo ni la imagen de la factura.
          </li>
          <li><strong>Consumidor final:</strong> las ventas sin cliente identificado se asocian al consumidor final genérico, que no contiene datos personales.</li>
        </Lista>
        <p>
          <em>Finalidades (las define el Negocio; {marca} las ejecuta):</em> identificar al cliente, asociar sus compras y
          contactarlo sobre ellas; registrar gastos y proveedores; generar reportes y archivos de exportación para el Negocio
          y su contador.
        </p>
        <p><em>Formulario público de registro de clientes:</em></p>
        <Lista>
          <li>Usa una verificación contra robots del proveedor de alojamiento, que analiza señales técnicas del navegador del visitante.</li>
          <li>La respuesta es la misma tanto si la persona ya estaba registrada como si no, de modo que desde el formulario nadie puede averiguar quién es cliente de un Negocio.</li>
          <li>Si la persona ya estaba registrada, sus datos no se modifican desde el formulario: los corrige el Negocio.</li>
        </Lista>
        <p><strong>Artículo 10. Datos sensibles y de menores de edad.</strong></p>
        <Lista>
          <li>{marca} no solicita datos sensibles. Si un Negocio decide registrarlos, le corresponde obtener la autorización explícita del titular (Ley 1581, art. 6).</li>
          <li>El formulario público no admite documentos de menores de edad.</li>
          <li>
            <Pendiente>
              [TBD: la app del Negocio sí permite registrar clientes con registro civil o tarjeta de identidad. Definir si se
              retira esa opción o si se exige y registra la autorización del representante legal (Ley 1581, art. 7).]
            </Pendiente>
          </li>
        </Lista>
        <p>
          <strong>Artículo 11. Datos en el dispositivo.</strong> Para no perder ventas ante cortes de internet, la app guarda
          en el navegador del equipo del Negocio:
        </p>
        <Lista>
          <li>la venta en curso y los pedidos abiertos;</li>
          <li>las ventas pendientes de enviar;</li>
          <li>durante el alta de la cuenta, los datos del formulario hasta que se confirma el código.</li>
        </Lista>
        <p>Esos datos se borran del dispositivo al enviarse o al completarse el alta.</p>
      </Seccion>

      <Seccion titulo="Capítulo VI — Principios">
        <p>
          <strong>Artículo 12. Principios.</strong> Se aplican los de legalidad, finalidad, libertad, veracidad,
          transparencia, acceso y circulación restringida, seguridad y confidencialidad (Ley 1581, art. 4), además de{' '}
          <strong>minimización</strong>:
        </p>
        <Lista>
          <li>{marca} pide solo los datos que el servicio necesita.</li>
          {/* eslint-disable-next-line no-restricted-syntax -- facturas de proveedores, que no se guardan */}
          <li>No guarda archivos ni fotos de facturas.</li>
          <li>No usa herramientas de analítica ni rastreadores de terceros.</li>
          <li>No vende, alquila ni cede datos.</li>
          <li>No usa los datos de los Negocios ni de sus terceros para publicidad.</li>
        </Lista>
      </Seccion>

      <Seccion titulo="Capítulo VII — Autorización">
        <p>
          <strong>Artículo 13. Autorización del propietario.</strong> Se otorga al crear el Negocio, con una casilla no
          premarcada y texto expreso. Queda registrada la fecha y hora.{' '}
          <Pendiente>[TBD: registrar también la versión de esta política y de los Términos de Servicio que se aceptan.]</Pendiente>
        </p>
        <p>
          <strong>Artículo 14. Autorización de los miembros invitados.</strong>{' '}
          <Pendiente>
            [TBD: hoy la invitación se acepta sin registrar autorización. Definir la casilla, su texto y el registro de
            fecha y versión antes de publicar esta política.]
          </Pendiente>
        </p>
        <p>
          <strong>Artículo 15. Autorización de los clientes de un Negocio.</strong> La obtiene el Negocio, como Responsable.
          La plataforma provee dos mecanismos:
        </p>
        <Lista>
          <li>En el formulario público, una casilla no premarcada con el texto de la autorización; se registra la fecha y hora.</li>
          <li>En la app, una casilla con la que quien registra declara que el cliente autorizó.</li>
        </Lista>
        <p>El silencio o una casilla premarcada nunca constituyen autorización.</p>
        <p>
          <strong>Artículo 16. Revocatoria.</strong> El titular puede revocar la autorización y pedir la supresión en
          cualquier momento, salvo que exista un deber legal o contractual de conservar los datos. Para el propietario,
          revocar implica terminar el servicio.
        </p>
      </Seccion>

      <Seccion titulo="Capítulo VIII — Conservación y supresión">
        <p>
          <strong>Artículo 17. Regla general.</strong> Los datos se conservan solo el tiempo necesario para su finalidad y
          para cumplir obligaciones legales.
        </p>
        <p><strong>Artículo 18. Plazos.</strong></p>
        <TablaLegal
          titulos={['Dato', 'Plazo']}
          filas={[
            ['Cuenta de propietario o miembro', <>Mientras la cuenta esté activa, más <Pendiente>[TBD: plazo posterior]</Pendiente></>],
            [
              'Operación del Negocio (ventas, comprobantes, gastos, cuadres, inventario)',
              <>Mientras el Negocio esté activo. Al terminar, <Pendiente>[TBD: días]</Pendiente> para exportar y luego supresión</>,
            ],
            [
              'Clientes de un Negocio',
              'Hasta que el Negocio los suprima o el titular lo pida. La supresión reemplaza nombre, celular y correo y sustituye el número de documento por un código no reversible; las ventas históricas se conservan sin identificar a la persona',
            ],
            ['Registro de auditoría (incluye fallos de pantalla e intentos de vinculación de Telegram)', '90 días; las comprobaciones automáticas de funcionamiento, 7 días'],
            ['Elementos en la papelera (productos, gastos)', '14 días por defecto; el Negocio puede fijar entre 1 y 365'],
            [
              'Sesiones (IP y agente de usuario)',
              <>Mientras la sesión exista; el propietario puede desconectarla. <Pendiente>[TBD: retención de los registros del proveedor de autenticación]</Pendiente></>,
            ],
            ['Chat de Telegram vinculado', 'Hasta que se vincule otro chat o se solicite la desvinculación'],
            ['Copias de respaldo', 'Diarias y cifradas; se conservan 90 días. Un dato suprimido puede permanecer en las copias hasta ese plazo'],
          ]}
        />
        <p>
          <strong>Artículo 19. Supresión.</strong> Procede a solicitud del titular (previa verificación de su identidad), al
          vencer los plazos anteriores o al cesar la finalidad, salvo deber legal de conservación. Cuando el dato pertenece a
          un Negocio, la ejecuta el Negocio con la acción de supresión de la plataforma, o {marca} por su instrucción.
        </p>
      </Seccion>

      <Seccion titulo="Capítulo IX — Transmisión internacional y proveedores">
        <p><strong>Artículo 20. Subencargados e infraestructura.</strong></p>
        <TablaLegal
          titulos={['Proveedor', 'Función', 'Ubicación']}
          filas={[
            ['Supabase', 'Base de datos, autenticación por código y funciones del servidor', <>Estados Unidos <Pendiente>[TBD: confirmar región]</Pendiente></>],
            [
              'Cloudflare',
              'Alojamiento de la app y del formulario público, bot de Telegram, verificación contra robots y almacenamiento de las copias de respaldo cifradas',
              <>Red global <Pendiente>[TBD: ubicación del almacenamiento de respaldos]</Pendiente></>,
            ],
            ['GitHub', 'Ejecución automatizada de las copias de respaldo; la copia se cifra antes de salir del entorno de ejecución', 'Estados Unidos'],
            ['Google', <><Pendiente>[TBD: confirmar si envía los correos con el código de acceso]</Pendiente> y alertas internas de operación</>, 'Estados Unidos / global'],
          ]}
        />
        <p><strong>Artículo 21. Garantías.</strong></p>
        <Lista>
          <li>
            La transmisión a estos proveedores se ampara en sus condiciones contractuales de tratamiento de datos{' '}
            <Pendiente>[TBD: verificar que cada una esté aceptada y archivada]</Pendiente>, que imponen seguridad,
            confidencialidad y restricción de uso (Decreto 1074 de 2015, art. 2.2.2.25.5.2).
          </li>
          <li>Estados Unidos figura en la lista de países con nivel adecuado de protección de la Superintendencia de Industria y Comercio.</li>
          <li>{marca} mantiene actualizada la lista de subencargados y la entrega a quien la solicite.</li>
        </Lista>
        <p>
          <strong>Artículo 22. Telegram.</strong> Vincular un chat de Telegram es opcional y lo decide el propietario. Una vez
          vinculado:
        </p>
        <Lista>
          <li>{marca} envía a ese chat resúmenes del Negocio: ventas del día con su total por cuenta, resultado del cuadre, insumos bajo el mínimo y pendientes de la semana.</li>
          <li>Los mensajes no incluyen datos de los clientes del Negocio.</li>
          <li>Viajan por la infraestructura de Telegram, cuyas condiciones acepta el propietario directamente con ese servicio.</li>
        </Lista>
      </Seccion>

      <Seccion titulo="Capítulo X — Medidas de seguridad">
        <p><strong>Artículo 23. Medidas implementadas.</strong></p>
        <Lista>
          <li>Cifrado en tránsito (HTTPS) en todos los canales.</li>
          <li>Aislamiento entre negocios con políticas de seguridad a nivel de fila en toda tabla: un Negocio no puede leer ni escribir datos de otro.</li>
          <li>Acceso sin contraseña, por código de un solo uso enviado al correo.</li>
          <li>Sesiones visibles y desconectables por el propietario (las de su Negocio) y por la plataforma.</li>
          <li>Vinculación de Telegram con un código de seis dígitos, de un solo uso, que vence a los 10 minutos, con límite de intentos por hora.</li>
          <li>Verificación contra robots en el formulario público, y respuesta que no revela quién es cliente.</li>
          <li>Copias de respaldo diarias, cifradas con AES-256, verificadas con simulacros de restauración.</li>
          <li>Registro de auditoría de las acciones sensibles y de las consultas del personal de la plataforma.</li>
          <li>Personal de la plataforma con permisos otorgados uno a uno y sin acceso a montos ni a datos de clientes de los Negocios.</li>
        </Lista>
        <p>
          <strong>Artículo 24. Gestión de incidentes.</strong> Ante un incidente de seguridad que afecte datos personales,{' '}
          {marca}:
        </p>
        <Lista numerada>
          <li>lo contiene y lo evalúa;</li>
          <li>lo documenta;</li>
          <li>notifica a los Negocios afectados y, cuando corresponda, a los titulares;</li>
          <li>lo reporta a la Superintendencia de Industria y Comercio cuando la ley lo exija;</li>
          <li>aplica los correctivos.</li>
        </Lista>
        <p><Pendiente>[TBD: plazo de notificación y tiempo de conservación del registro de incidentes.]</Pendiente></p>
      </Seccion>

      <Seccion titulo="Capítulo XI — Derechos de los titulares y procedimiento">
        <p><strong>Artículo 25. Derechos.</strong> Todo titular puede:</p>
        <Lista>
          <li>conocer, actualizar y rectificar sus datos;</li>
          <li>solicitar prueba de la autorización;</li>
          <li>ser informado del uso dado a sus datos;</li>
          <li>presentar quejas ante la Superintendencia de Industria y Comercio, una vez agotado el trámite ante el Responsable o el Encargado;</li>
          <li>revocar la autorización y solicitar la supresión cuando proceda;</li>
          <li>acceder gratuitamente a sus datos (Ley 1581, art. 8).</li>
        </Lista>
        <p>Pueden ejercerlos el titular, sus causahabientes, su representante o apoderado, y quien actúe por estipulación a favor de otro.</p>
        <p><strong>Artículo 26. Canal y plazos.</strong></p>
        <Lista>
          <li>
            <strong>Canal:</strong> <Pendiente>[TBD: correo de contacto]</Pendiente>, con el asunto «Habeas data». Atiende{' '}
            <Pendiente>[TBD: persona o área responsable]</Pendiente>.
          </li>
          <li>
            <strong>Consultas:</strong> respuesta en máximo 10 días hábiles, prorrogables por 5 más con aviso del motivo (Ley
            1581, art. 14). La primera consulta de cada mes es gratuita.
          </li>
          <li>
            <strong>Reclamos:</strong> respuesta en máximo 15 días hábiles desde el día siguiente a su recibo, prorrogables por
            8 más con aviso del motivo (art. 15).
            <Lista>
              <li>Si el reclamo está incompleto, se pide subsanarlo dentro de los 5 días siguientes. Pasados 2 meses sin respuesta, se entiende desistido.</li>
              <li>Recibido el reclamo completo, el dato se marca como «reclamo en trámite» en máximo 2 días hábiles, hasta que se decida.</li>
            </Lista>
          </li>
          <li>Se verifica razonablemente la identidad de quien solicita. Toda solicitud y respuesta quedan registradas.</li>
        </Lista>
        <p><strong>Artículo 27. Solicitudes sobre datos de un Negocio.</strong></p>
        <Lista>
          <li>Cuando un cliente o proveedor de un Negocio ejerce sus derechos ante {marca}, {marca} da traslado al Negocio dentro de 2 días hábiles e informa al titular.</li>
          <li>Como Encargado, {marca} actualiza, rectifica o suprime lo que el Negocio le indique dentro de los 5 días hábiles siguientes (Ley 1581, art. 18).</li>
        </Lista>
      </Seccion>

      <Seccion titulo="Capítulo XII — Vigencia">
        <p>
          <strong>Artículo 28. Vigencia de la política y de las bases de datos.</strong> Esta política rige desde su
          publicación en {window.location.origin}/legal/politica-datos y permanece vigente mientras se traten datos
          personales. Las bases de datos se mantienen mientras sean necesarias para las finalidades descritas y los plazos
          del capítulo VIII.
        </p>
        <p>
          <strong>Artículo 29. Actualización.</strong> Se revisa al menos una vez al año y cada vez que cambien la normativa,
          los proveedores o el funcionamiento de la plataforma. Los cambios sustanciales se comunican a los propietarios
          antes de entrar en vigor.
        </p>
      </Seccion>
    </PaginaLegal>
  );
}
